import moment from 'moment'

export function useUtilities() {
  const appendQueryParams = (data: Record<string, any>) => {
    return `?${Object.keys(data).map(k => `${k}=${data[k]}`).join("&")}`
  }

  const formatDate = (date: string | Date | null) => {
    if (date) {
      return moment(date).format("DD/MM/YYYY")
    }
    return ""
  }

  const dateFormat = (date: string | Date | null) => {
    if (date) {
      return moment(date).format("DD/MM/YYYY")
    }
    return ""
  }

  const cleanUnderscoreString = (name: string) => {
    const n = name.replaceAll("_", " ")
    return n.charAt(0).toUpperCase() + n.slice(1)
  }

  const cleanEntityType = (name: string) => {
    const n = name.replaceAll("-", " ")
    return n.charAt(0).toUpperCase() + n.slice(1)
  }

  const cleanUnderscores = (name: string) => {
    const n = name.replaceAll("_", " ")
    return n.charAt(0).toUpperCase() + n.slice(1)
  }

  const onlyNumberValidator = (event: KeyboardEvent) => {
    if (!/[\d]/.test(event.key)) return event.preventDefault()
  }

  const objectToQueryParams = (objectToParse: Record<string, any>) => {
    return Object.keys(objectToParse).map(key => key + '=' + objectToParse[key]).join('&')
  }

  const generateRandomDivisibleBy4 = () => {
    let resultString = ""

    for (let i = 0; i < 17; i++) {
      const randomNumber = Math.floor(Math.random() * 6) + 4
      resultString += randomNumber.toString()
    }

    return resultString
  }

  const getCenterThreeDigits = (number: string) => {
    const numString = number.toString()
    const startIndex = Math.floor((numString.length - 3) / 2)
    return numString.substr(startIndex, 3)
  }

  const manipulateNumber = (number: string) => {
    const centerThreeDigits = getCenterThreeDigits(number)
    const multipliedResult = parseInt(centerThreeDigits) * 3
    const firstTwoDigits = Math.floor(multipliedResult / 100)
    const lastTwoDigits = multipliedResult % 100

    return firstTwoDigits.toString() +
        number.toString() +
        lastTwoDigits.toString()
  }

  const getReference = () => {
    const randomDivisibleBy4 = generateRandomDivisibleBy4()
    return manipulateNumber(randomDivisibleBy4)
  }

  const filterUnitData = (data: any[]) => {
    const arrayData: any[] = []
    let obj: any = {}
    data.forEach(list => {
      obj = {
        value: list.id,
        text: list.name ? list.name.toUpperCase() : "",
        id: list.id,
        name: list.name ? list.name.toUpperCase() : ""
      }
      arrayData.push(obj)
    })

    arrayData.sort(function (a, b) {
      if (a.text < b.text) return -1
      if (a.text > b.text) return 1
      return 0
    })

    return arrayData
  }

  return {
    appendQueryParams,
    formatDate,
    dateFormat,
    cleanUnderscoreString,
    cleanEntityType,
    cleanUnderscores,
    onlyNumberValidator,
    objectToQueryParams,
    getReference,
    generateRandomDivisibleBy4,
    getCenterThreeDigits,
    manipulateNumber,
    filterUnitData,
  }
}
